declare interface Date {
    differenceInMinute: (date?: Date) => number;

    addDays(days: number): Date;

    copyAndAddDays(days: number): Date;

    setClock(hours: number, minutes?: number): Date;

    toUTC(): Date;

    atMidnight(): Date;
}

Date.prototype.addDays = function (days): Date {
    this.setDate(this.getDate() + days);
    return this;
};

Date.prototype.copyAndAddDays = function (days): Date {
    const date = new Date(this);
    date.setDate(this.getDate() + days);
    return date;
};

Date.prototype.setClock = function (hours: number, minutes = 0): Date {
    this.setHours(hours, minutes);
    return this;
};

Date.prototype.toUTC = function (): Date {
    return new Date(
        Date.UTC(
            this.getUTCFullYear(),
            this.getUTCMonth(),
            this.getUTCDate(),
            this.getUTCHours(),
            this.getUTCMinutes(),
            this.getUTCSeconds()
        )
    );
};

Date.prototype.atMidnight = function (): Date {
    const date = new Date(this);
    date.setHours(0, 0, 0);
    return date;
};

Date.prototype.differenceInMinute = function (date: Date = new Date()): number {
    const diffMs = this.getTime() - date.getTime();
    return Math.round(((diffMs % 86400000) % 3600000) / 60000);
};
